import React, {Component} from 'react'

class NavBar extends Component {

    render(){
        return(
            <nav>
                <div className="nav-wrapper light-blue darken-2">
                <a className="brand-logo center">Student Visualization</a>
                </div>
            </nav>
        )
    }
}

export default NavBar;


// WEBPACK FOOTER //
// ./src/components/NavBar.js